import { HorizontalBarGraph } from "../../Charts/HorizontalBarGraph/HorizontalBarGraph";
import { BlankState } from "../BotAnalyticsDashboard";
import { Spinner } from "@swivl-mono/ui";

export const Cortex = ({ cortexData, colors, onViewAll }) => {
    let content, total, viewAll;
    if (cortexData) {
      if (Array.isArray(cortexData) && cortexData.length > 0) {
        const totalSum = cortexData.reduce((acc, item) => acc + item.value, 0).toLocaleString();
        const data = cortexData
          .sort((a, b) => b.value - a.value)
          .slice(0, 5)
          .map((item, index) => ({
            title: item.title,
            rows: [{ value: item.value, color: colors[index % colors.length] }],
            total: item.value,
          }));
        total = data.reduce((acc, item) => acc + item.total, 0).toLocaleString();
        content = (
          <div className="barAndPieWapper">
            <HorizontalBarGraph data={data} showTotals={true} />
          </div>
        );
        viewAll = (
          <a className="viewAll" onClick={onViewAll}>
            VIEW ALL
          </a>
        );
        total = totalSum;
      } else {
        content = <div className="loadingContent">{BlankState()}</div>;
      }
    } else {
      content = (
        <div className="loadingContent">
          <Spinner />
        </div>
      );
    }
    return (
      <div className="chartBox">
        <div className="chartHeader">
          <div className="chartHeaderTitle">
            <span>Top Bot Responses</span>
          </div>
          <div className="spacer" />
          <div className="headerTotal">{total}</div>
        </div>
        <div className="chartContent">{content}</div>
        {viewAll}
      </div>
    );
  }


  export const AllCortex = ({ cortexData, onViewLess }) => {
    const titleToUrlMap = {
      "CTA Messages": "/properties/page/cortex/engagement/custom-call-to-action",
      Tour: "/properties/page/cortex/access/tour",
      "Key Access/Lock": "/properties/page/cortex/access/key-access",
      "Gate Code": "/properties/page/cortex/access/gate-code",
      "After Hours Access": "/properties/page/cortex/access/after-hours",
      "Pay Bill": "/properties/page/cortex/account-management/pay-bill",
      "Auto Pay": "/properties/page/cortex/account-management/auto-pay",
      "Change Due Date": "/properties/page/cortex/account-management/due-date",
      "Update Contact Info": "/properties/page/cortex/account-management/update-contact-info",
      "Reset Password": "/properties/page/cortex/account-management/reset-password",
      "Forgot Username": "/properties/page/cortex/account-management/forgot-username",
      "Update Billing Info": "/properties/page/cortex/account-management/update-billing",
      "Create Login": "/properties/page/cortex/account-management/create-login",
      "Grace Period": "/properties/page/cortex/account-management/grace-period",
      Reservation: "/properties/page/cortex/account-management/reservation",
      "Cancel Service": "/properties/page/cortex/account-management/cancel-service",
      "Past Due": "/properties/page/cortex/account-management/past-due",
      "Hold Unit": "/properties/page/cortex/account-management/hold-unit",
      "Standard Ceiling Height": "/properties/page/cortex/sizing/ceiling-height",
      "Climate Control": "/properties/page/cortex/features-amenities/climate-control",
      Security: "/properties/page/cortex/features-amenities/security",
      "Outdoor Parking": "/properties/page/cortex/parking-vehicles/outdoor",
      "Drive Up Units": "/properties/page/cortex/features-amenities/driveup-units",
      "Maintenance Pest": "/properties/page/cortex/features-amenities/maintenance",
      Lights: "/properties/page/cortex/features-amenities/lights",
      "Packing Supplies": "/properties/page/cortex/features-amenities/packing-supplies",
      "Moving Truck": "/properties/page/cortex/features-amenities/moving-truck",
      "Moving Services": "/properties/page/cortex/features-amenities/moving-services",
      Dollies: "/properties/page/cortex/features-amenities/dollies",
      Auctions: "/properties/page/cortex/features-amenities/auctions",
      "Auction Winners": "/properties/page/cortex/features-amenities/auction-winners",
      Franchise: "/properties/page/cortex/features-amenities/franchise",
      "Wine Storage": "/properties/page/cortex/features-amenities/wine",
      "Get Out": "/properties/page/cortex/issue-resolution/get-out",
      "Billing Issue": "/properties/page/cortex/issue-resolution/billing-issue",
      Emergency: "/properties/page/cortex/issue-resolution/emergency",
      "Web Issue": "/properties/page/cortex/issue-resolution/web-issues",
      "Damaged Items": "/properties/page/cortex/issue-resolution/damaged-items",
      Theft: "/properties/page/cortex/issue-resolution/theft",
      "Lost Key": "/properties/page/cortex/issue-resolution/lost-key",
      Pricing: "/properties/page/cortex/pricing/pricing",
      "Purchase Payment Options": "/properties/page/cortex/pricing/payment-options",
      "Pay Online": "/properties/page/cortex/lease/pay-online",
      "Storable Items": "/properties/page/cortex/lease/storable-items",
      "Contract Lengths": "/properties/page/cortex/lease/contract-lengths",
      "Facility Access": "/properties/page/cortex/lease/facility-access",
      Identification: "/properties/page/cortex/lease/identification",
      Cancellation: "/properties/page/cortex/lease/cancellation",
      "Move Out Policy": "/properties/page/cortex/lease/moveout-policy",
      Refunds: "/properties/page/cortex/lease/refunds",
      Prorate: "/properties/page/cortex/lease/prorate",
      "Lease: Insurance": "/properties/page/cortex/lease/insurance",
      Claim: "/properties/page/cortex/lease/file-claim",
      Covid: "/properties/page/cortex/lease/covid",
      "Cut Locks": "/properties/page/cortex/lease/cut-locks",
      Overlock: "/properties/page/cortex/lease/overlock",
      "Live In Unit": "/properties/page/cortex/lease/live-in-unit",
      "Vehicle Storage Guidelines": "/properties/page/cortex/parking-vehicles/vehicle-guidelines",
      "Unit Transfer": "/properties/page/cortex/lease/unit-transfer",
      "Work In Unit": "/properties/page/cortex/lease/work-inUnit",
      "Admin Fee": "/properties/page/cortex/pricing/admin-fee",
      "Late Fee": "/properties/page/cortex/pricing/late-fee",
      "Rate Increase": "/properties/page/cortex/pricing/rate-increase",
      "Web Rates": "/properties/page/cortex/pricing/web-rates",
      "Insurance Cost": "/properties/page/cortex/pricing/insurance-cost",
      "Credit Card Fee": "/properties/page/cortex/pricing/credit-card-fee",
      Referral: "/properties/page/cortex/pricing/referral",
      "Account Balance": "/properties/page/cortex/account-management/account-balance",
      "Payment Issue": "/properties/page/cortex/issue-resolution/payment-issue",
      "Payment Extension": "/properties/page/cortex/account-management/payment-extension",
      "Partial Payment": "/properties/page/cortex/account-management/partial-payment",
      "Payment History": "/properties/page/cortex/account-management/payment-history",
      "Billing Dispute": "/properties/page/cortex/account-management/billing-dispute",
      "Get Lease": "/properties/page/cortex/lease/get-lease",
      "Manage Insurance": "/properties/page/cortex/account-management/manage-insurance",
      "Unit Size": "/properties/page/cortex/account-management/unit-size",
      "Multiple Accounts": "/properties/page/cortex/account-management/multiple-accounts",
      // "Account Login Issues": "/properties/page/cortex/account-management/account-login-issues",
      // "Account General Management": "/properties/page/cortex/account-management/account-general-management",
      "Unit Number": "/properties/page/cortex/access/unit-number",
      // "Navigate to Account Login": "/properties/page/cortex/account-management/navigate-to-account-login",
    };
    return (
      <div className="viewingAll">
        <h2>All Bot Responses</h2>
        <ul>
          {cortexData &&
            cortexData.map((item, index) => (
              <li key={index}>
                <a href={titleToUrlMap[item.title] || "#"} target="_blank" rel="noopener noreferrer">
                  {item.title}
                </a>
                : <span>{item.value}</span>
              </li>
            ))}
        </ul>
        <button className="viewAll" onClick={onViewLess}>
          VIEW LESS
        </button>
      </div>
    );
  }